import { connect } from 'react-redux'
import { get } from 'lodash'

import CartDetails from '../components/CartDetails'
import { getSubtotal, getTax, getTotal } from '../selectors/cart'
import CartDetailsViewModel from '../viewmodels/CartDetailsViewModel'

const mapStateToProps = (state, ownProps) => {
  // if a tabbed order is passed in, we should add the previous total to the running total
  const order = get(ownProps, 'order', {})
  const orderSubtotal = order.amountInCents || 0 // there's no separate subtotal
  const orderTax = order.taxInCents || 0 // this doesn't exist yet
  const orderTotal = order.amountInCents || 0

  const subtotal = getSubtotal(state) + orderSubtotal
  const tax = getTax(state) + orderTax
  const total = getTotal(state) + orderTotal

  return CartDetailsViewModel({ subtotal, tax, total })
}

export default connect(mapStateToProps, undefined)(CartDetails)
